export default {
    'list.nomore': '没有更多了'
}